module.exports = __webpack_public_path__ + "static/img/business9.56875c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business9.jpg
// module id = SULY
// module chunks = 9